import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, Route, Switch } from 'react-router-dom'
import { Popup, Flex, Content, Text, Portal, Button } from '@leverege/ui-elements'
import { Auth } from '@leverege/api-redux'
import { push } from 'connected-react-router'
import classnames from 'classnames'

import { ProjectActions } from '~/actions'
import HomeScreen from './HomeScreen.jsx'
import ProjectScreen from '~/screens/project/ProjectScreen.jsx'
import ProjectError from '~/screens/project/ProjectError.jsx'

import style from './style.css'
import UserScreen from './UserScreen.jsx'
import MaintenanceEventHomeScreen from '../maintenanceEvent/MaintenanceEventHomeScreen.jsx'
import ProfileScreen from '../profile/ProfileScreen.jsx'

export class MainScreen extends React.Component {

  static routes = [
    <Route key="" path="/" exact component={HomeScreen} />,
    <Route key="project" path="/project/:projectId" exact={false} component={ProjectScreen} />,
    <Route key="users" path="/users" exact component={UserScreen} />,
    <Route key="maintenanceEvent" path="/maintenanceEvent" exact component={MaintenanceEventHomeScreen} />,
    <Route key="profile" path="/profile" exact component={ProfileScreen} />,
    <Route key="index" path="/" exact={false} component={ProjectError} />
  ]

  static propTypes = {
    auth : PropTypes.object
  }

  componentDidMount() {
    const { dispatch } = this.props 
    dispatch( ProjectActions.getProjects( ) );
  }

  onProfile = () => {
    const { history } = this.props
    history.push( '/profile' )
  }

  onSwitchProjects = () => {
    const { history } = this.props 
    history.push( '/' )
  }

  onLogout = () => {
    const { auth, history, dispatch } = this.props 
    
    dispatch( Auth.logout() )
      .then( () => {
        dispatch( push( '/' ) )
      } )
  }

  render() {
    const { auth, projects, history } = this.props

    const { pathname } = history.location
    const profile = auth?.profile
    const pSplit = pathname?.split( '/' )
    const projectId = pSplit?.[pSplit.indexOf( 'project' ) + 1]
    const project = projects?.projects?.find?.( i => i.id === projectId )

    return (
      <div>
        <Content.Header variant="navHeader" style={{ backgroundColor : project?.color }} >
          <Flex
            align="center"
            justify="space-between"
            className={style.header}>
            <Flex variant="rowXL" className={style.header}>
              <Button variant="navLogo" onClick={() => history.push( '/' )} />
              <Text variant="navLogoSubLabel">{project?.name || 'Leverege Platform'}</Text>

            </Flex>
            <Flex className={style.navContainer} variant="row">
              {
                ( pathname === '/' || pathname === '/users' ) ?
                  (
                    <React.Fragment>
                      <Button
                        className={classnames( style.events, style.win )}
                        variant="nav"
                        onClick={() => history.push( '/maintenanceEvent' )}>Maintenance Events
                      </Button>
                      <Button
                        className={classnames( style.users, style.win )}
                        variant="nav"
                        onClick={() => history.push( '/users' )}>Users
                      </Button>
                    </React.Fragment>
                  ) : null
              }
              <Popup
                toggleVariant="navHeader"
                title={<Text variant="navLogoSubLabel">{profile.name}</Text>}>
                <Popup.Item onClick={this.onProfile}>Profile</Popup.Item>
                <Popup.Item onClick={this.onSwitchProjects}>Switch Projects</Popup.Item>
                <Popup.Divider />
                <Popup.Item onClick={this.onLogout}>Sign Out</Popup.Item>
              </Popup>
            </Flex>
          </Flex>
        </Content.Header>
        <div className={style.content}>
          <Portal id="portal" />
          <Switch>{MainScreen.routes}</Switch>
        </div>
      </div>
    )
  }
}

export default withRouter( connect(
  state => ( {
    project : state.project,
    projects : state.projects,
    auth : state.auth
  } )
)( MainScreen ) )
